import { render, staticRenderFns } from "./sorotecageladeiras.vue?vue&type=template&id=0a6aa728&"
import script from "./sorotecageladeiras.vue?vue&type=script&lang=js&"
export * from "./sorotecageladeiras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports